import toast from 'react-hot-toast';
import { useUpdateCustomMasterFund } from '../../../../../../../services/jurisdiction.service';
import DebouncedInput from '../DebouncedInput';
import { extractApiError } from '../../../../../../../utils';

export default function CustomMasterFundNameInput({
  initialValue,
  onChange,
  workflowId,
  masterFundId
}) {
  const updateCustomMasterFund = useUpdateCustomMasterFund({
    workflowId,
    queryParams: {
      enabled: !!masterFundId
    }
  });

  const onUpdateMasterFundName = newName => {
    if (!newName) return toast.error('Custom Master Fund Name cannot be empty');

    updateCustomMasterFund.mutate(
      {
        masterFundId,
        data: {
          fund_name: newName
        }
      },
      {
        onSuccess: res => {
          onChange?.(res);
        },
        onError: err => {
          console.error('Error updating Custom Master Fund Name:', err);
          toast.error(extractApiError(err, 'Unable to update this custom master fund name.'));
        }
      }
    );
  };

  return (
    <DebouncedInput
      data-testid="custom-master-fund-name-input"
      initialValue={initialValue}
      disabled={updateCustomMasterFund.isLoading}
      onChange={onUpdateMasterFundName}
      placeholder="Enter Custom Master Fund Name"
    />
  );
}
